import { TextField, FormControlLabel, Switch } from "@mui/material";
import { ReactElement } from "react";

interface ITopPanelProps  {
  updateStyle: (style: Record<string, any>) => void;
  style: Record<string, any>;
}

const StylePanel = ({ style, updateStyle }: ITopPanelProps): ReactElement =>  {

  const onChange = (key: string, value: unknown) => {
    updateStyle({ ...style, [key]: value });
  };

  return (
    <div className="display-flex-row">
      <TextField
        className="m-1"
        label="Scale"
        sx={{ width: 200 }}
        variant="standard"
        size="small"
        value={style.scale ?? 1}
        type="number"
        slotProps={{ input: {  inputProps: { min: 0.5, max: 5 } }}}
        onChange={(event) => onChange("scale", parseFloat(event.target.value as string))} />

      <FormControlLabel
        control={<Switch checked={style.showValue ?? false} onChange={(event) => onChange("showValue", event.target.checked)} name="isPrivate" />}
        label="Private"
      />
    </div>
  );
};

export default StylePanel;
